'use client'

import React from 'react'
import { Modal, Button, ProgressBar } from '@ds/ui'

interface NumKeyModalProps {
  isOpen: boolean;
  progress: number;
  onCancel: () => void;
  onComplete?: () => void;
  mode?: 'create' | 'export';
}

const NumKeyModal: React.FC<NumKeyModalProps> = ({ 
  isOpen, 
  progress, 
  onCancel,
  onComplete = () => {},
  mode = 'export'
}) => {
  const isCompleted = progress === 100;
  const title = mode === 'create' ? 'Creating Numbered Keys' : 'Exporting Numbered Keys';
  
  return (
    <Modal
      visible={isOpen}
      closeButton={<Modal.Close onClick={onCancel} />}  
      width="medium"
    >
      <Modal.Header title={title} />
      <Modal.Body>
        <ProgressBar 
          kind="info" 
          label='Progress'
          content={`${progress}%`} 
          value={progress} 
        />
      </Modal.Body>
      <Modal.Footer>
        <Button 
          kind="secondary" 
          onClick={onCancel} 
          text="Cancel" 
          disabled={isCompleted}
        />
        <Button 
          kind="primary" 
          disabled={!isCompleted} 
          text="OK" 
          onClick={onComplete || onCancel}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default NumKeyModal;
